import { ChooserBarItem } from './chooser-bar/chooser-bar-item';


export function getTenorChooserBarItems(): ChooserBarItem[] {
    const items: ChooserBarItem[] = [];
    for (let i = 1; i <= 999; i++) {
        items.push({ label: `${i}D`, value: `${i}D` } as ChooserBarItem);
    }
    for (let i = 1; i <= 52; i++) {
        items.push({ label: `${i}W`, value: `${i}W` } as ChooserBarItem);
    }
    for (let i = 1; i <= 360; i++) {
        items.push({ label: `${i}M`, value: `${i}M` } as ChooserBarItem);
    }
    for (let i = 1; i <= 50; i++) {
        items.push({ label: `${i}Y`, value: `${i}Y` } as ChooserBarItem);
    }
    return items;
}